import { render } from "./AdminFooter.vue?vue&type=template&id=d60faaea&scoped=true"
import script from "./AdminFooter.vue?vue&type=script&lang=js"
export * from "./AdminFooter.vue?vue&type=script&lang=js"

import "./AdminFooter.vue?vue&type=style&index=0&id=d60faaea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d60faaea"]])

export default __exports__